import React from 'react';
import ProgressSpinner from '@smart-tv/components/progress-spinner/progress-spinner';
import styles from './npvr.module.scss';

export const NpvrLoading: React.FC = () => (
  <div className={styles['npvr__loading']}>
    <ProgressSpinner className={styles['npvr__loading-spinner']} />
  </div>
);

export default NpvrLoading;
